export default {
  feedback: {
    usage_threshold: 'Suma minimă a coșului pentru această promoție este (fără costurile de livrare)',
    promo_code_added: 'Cod promoțional aplicat',
    promo_code_removed: 'Codul promoțional {{code}} eliminat',
  },
};
